var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 12.4998C3.39018 12.4998 3.00189 12.4998 2.69561 12.373C2.28723 12.2038 1.96277 11.8794 1.79362 11.471C1.66675 11.1647 1.66675 10.7764 1.66675 9.99984V4.33317C1.66675 3.39975 1.66675 2.93304 1.8484 2.57652C2.00819 2.26292 2.26316 2.00795 2.57676 1.84816C2.93328 1.6665 3.39999 1.6665 4.33341 1.6665H10.0001C10.7767 1.6665 11.1649 1.6665 11.4712 1.79337C11.8796 1.96253 12.2041 2.28698 12.3732 2.69536C12.5001 3.00165 12.5001 3.38993 12.5001 4.1665M10.1667 18.3332H15.6667C16.6002 18.3332 17.0669 18.3332 17.4234 18.1515C17.737 17.9917 17.992 17.7368 18.1518 17.4232C18.3334 17.0666 18.3334 16.5999 18.3334 15.6665V10.1665C18.3334 9.23308 18.3334 8.76637 18.1518 8.40985C17.992 8.09625 17.737 7.84128 17.4234 7.68149C17.0669 7.49984 16.6002 7.49984 15.6667 7.49984H10.1667C9.23333 7.49984 8.76662 7.49984 8.4101 7.68149C8.09649 7.84128 7.84153 8.09625 7.68174 8.40985C7.50008 8.76637 7.50008 9.23308 7.50008 10.1665V15.6665C7.50008 16.5999 7.50008 17.0666 7.68174 17.4232C7.84153 17.7368 8.09649 17.9917 8.4101 18.1515C8.76662 18.3332 9.23333 18.3332 10.1667 18.3332Z",
    stroke: "#5C667B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.95eb1a6a74ef1a8bb15dec2e7be3ec6e.svg";
export { ForwardRef as ReactComponent };